export type LoadingMessage =
  | 'DEFAULT_THINKING'
  | 'HOTEL_SEARCH'
  | 'HOTEL_DETAILS'
  | 'REDIRECT'
  | 'WRAP_UP'
  | 'REVIEWING_OPTIONS'
  | 'REFINING_RESULTS';

export const MIN_PHASE_DISPLAY_DURATION_MS = 2000;

export const LOADING_MESSAGE_TEXT: Record<LoadingMessage, string> = {
  DEFAULT_THINKING: 'Working on your request...',
  HOTEL_SEARCH: 'Searching for hotels...',
  HOTEL_DETAILS: 'Gathering details...',
  REDIRECT: 'Looking into that for you...',
  WRAP_UP: 'Putting everything together...',
  REVIEWING_OPTIONS: 'Reviewing the best options...',
  REFINING_RESULTS: 'Refining your results...',
};

const HOTEL_DETAILS_TOOLS = new Set([
  'get_hotel_things_to_do',
  'get_hotel_profile',
  'get_hotel_room_amenities',
  'get_hotel_transport',
  'get_hotel_meetings',
]);

/**
 * Maps a tool name from node_planning_completed payload to a LoadingMessage phase.
 * Returns null for unrecognized tools (caller should ignore the event).
 */
export function toolToLoadingMessage(tool: string | undefined | null): LoadingMessage | null {
  if (!tool) return null;
  if (tool === 'nls_hotel_search') return 'HOTEL_SEARCH';
  if (HOTEL_DETAILS_TOOLS.has(tool)) return 'HOTEL_DETAILS';
  if (tool === 'get_redirect_info' || tool === 'get_loyalty_details') return 'REDIRECT';
  if (tool === 'format_response') return 'WRAP_UP';
  return null;
}
